import CreationForm from './CreationForm';
import { withModel } from '../../../data-providers/model';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { fetchPrismicProduct } from 'src/client/js/store/thunks/prismic/product';

const enhance = compose(
  connect(null, dispatch => ({
    fetchPrismicProduct: (sku, locale) =>
      dispatch(fetchPrismicProduct(sku, locale)),
  })),
  withModel,
);

export default enhance(CreationForm);



// WEBPACK FOOTER //
// ./src/client/js/view/routes/Widgets/CreationForm/index.js